import {
  EcommercePerformanceAction,
  LOAD_ECOMMERCE_PERFORMANCE,
  LOAD_ECOMMERCE_PERFORMANCE_FAIL,
  LOAD_ECOMMERCE_PERFORMANCE_SUCCESS,
  LoadEcommercePerformance,
  LoadEcommercePerformanceFail,
  LoadEcommercePerformanceSuccess
} from "../actions";

export interface IEcommercePerformanceEntityState {
  data: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommercePerformanceState {
  entities: { [websiteId: number]: IEcommercePerformanceEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommercePerformanceState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommercePerformanceState = initialState, action: EcommercePerformanceAction): IEcommercePerformanceState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_PERFORMANCE:
      payload = (<LoadEcommercePerformance>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_PERFORMANCE_SUCCESS:
      payload = (<LoadEcommercePerformanceSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_PERFORMANCE_FAIL:
      payload = (<LoadEcommercePerformanceFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
